<template>
  <div style="width:100%; height:100%;">
    <el-row>
      <el-col :span="20">
        <el-input v-model="params.title">
          <template slot="prepend">
            <div @click="show = !show" class="search-label">
              高级搜索
              <i :class="show?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
            </div>
          </template>
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="basicSearch()" style="height: 50px; background-color: #006f6f; border-color: #006f6f;">全站搜索</el-button>
      </el-col>
    </el-row>
      <el-card v-show="show">
        <el-row style="padding-left: 60px">
          <span>时间</span>
          <el-select size="mini" placeholder="时间" filterable clearable v-model="params.year" @change="selectYear">
            <el-option v-for="item in ops.years" :key="item.item" :value="item.item" :label="item.label"></el-option>
          </el-select>
          <el-divider direction="vertical"></el-divider>
          <span>语言</span>
          <el-select size="mini" placeholder="语言" clearable v-model="params.language" @change="selectLanguage">
            <el-option v-for="item in ops.languages" :key="item.item" :value="item.item" :label="item.label"></el-option>
          </el-select>
          <el-divider direction="vertical"></el-divider>
          <span>主题</span>
          <el-select size="mini" placeholder="主题" clearable v-model="params.subject" @chagne="selectSubject">
            <el-option v-for="item in ops.subjects" :key="item.item" :value="item.item" :label="item.label"></el-option>
          </el-select>
          <el-divider v-if="params.language==='cn'" direction="vertical"></el-divider>
          <span v-if="params.language==='cn'">期刊</span>
          <el-select v-if="params.language==='cn'" size="mini" placeholder="期刊" filterable clearable v-model="params.journal" @change="selectJournal">
            <el-option v-for="item in ops.journals" :key="item.item" :value="item.item" :label="item.label"></el-option>
          </el-select>
          <el-divider v-if="params.language==='cn'" direction="vertical"></el-divider>
          <span v-if="params.language==='cn'">作者</span>
          <el-select v-if="params.language==='cn'" size="mini" placeholder="作者" filterable clearable allow-create v-model="params.author">
            <el-option v-for="item in ops.authors" :key="item.item" :value="item.item" :label="item.label"></el-option>
          </el-select>
          <p></p>
          <el-button type="warning"  @click="advancedSearch()"  style="margin-left:32px;background-color: #76be69; border-color: #76be69;">搜索</el-button>

        </el-row>
      </el-card>
  </div>
</template>

<script>
import { getInstanceYears, getSubject, getInstance, getAuthor, getLanguage } from '@/api/instance'
export default {
  data () {
    return {
      show: false,
      params: {
        year: '',
        language: '',
        subject: '',
        journal: '',
        author: '',
        title: ''
      },
      ops: {
        years: [],
        languages: [],
        subjects: [],
        journals: [],
        authors: []
      }
    }
  },
  mounted () {
    getInstanceYears({}).then(({data}) => {
      this.ops.years = data
    })
    getLanguage({}).then(({data}) => {
      this.ops.languages = data
    })
    getInstance({}).then(({data}) => {
      this.ops.journals = data
    })
    getAuthor({}).then(({data}) => {
      this.ops.authors = data
    })
    getSubject({}).then(({data}) => {
      this.ops.subjects = data
    })
  },
  methods: {
    basicSearch () {
      this.$emit('search', this.params)
    },
    advancedSearch () {
      this.$emit('search', this.params)
    },
    selectYear (val) {
      if (val !== '') {
        this.params.year = val
      }
    },
    selectLanguage (val) {
      if (val !== '') {
        this.params.language = val
      }
    },
    selectJournal (val) {
      if (val !== '') {
        this.params.journal = val
      }
    },
    selectAuthor (val) {
      if (val !== '') {
        this.params.author = val
      }
    },
    selectSubject (val) {
      if (val !== '') {
        this.params.subject = val
      }
    }
  },
  watch: {
    'params.year' (val) {
      getInstance(this.params).then(({data}) => {
        this.ops.journals = data
      })
      getLanguage(this.params).then(({data}) => {
        this.ops.languages = data
      })
      getAuthor(this.params).then(({data}) => {
        this.ops.authors = data
      })
      getSubject(this.params).then(({data}) => {
        this.ops.subjects = data
      })
    },
    'params.language' (val) {
      if (val !== 'cn') {
        this.params.journal = ''
        this.params.author = ''
      }
      getInstanceYears(this.params).then(({data}) => {
        this.ops.years = data
      })
      getInstance(this.params).then(({data}) => {
        this.ops.journals = data
      })
      getAuthor(this.params).then(({data}) => {
        this.ops.authors = data
      })
      getSubject(this.params).then(({data}) => {
        this.ops.subjects = data
      })
    },
    'params.journal' (val) {
      getInstanceYears(this.params).then(({data}) => {
        this.ops.years = data
      })
      getLanguage({}).then(({data}) => {
        this.ops.languages = data
      })
      getAuthor(this.params).then(({data}) => {
        this.ops.authors = data
      })
      getSubject(this.params).then(({data}) => {
        this.ops.subjects = data
      })
    },
    'params.author' (val) {
      getInstanceYears(this.params).then(({data}) => {
        this.ops.years = data
      })
      getLanguage({}).then(({data}) => {
        this.ops.languages = data
      })
      getInstance(this.params).then(({data}) => {
        this.ops.journals = data
      })
      getSubject(this.params).then(({data}) => {
        this.ops.subjects = data
      })
    },
    'params.subject' (val) {
      getInstanceYears(this.params).then(({data}) => {
        this.ops.years = data
      })
      getLanguage(this.params).then(({data}) => {
        this.ops.languages = data
      })
      getInstance(this.params).then(({data}) => {
        this.ops.journals = data
      })
      getAuthor(this.params).then(({data}) => {
        this.ops.authors = data
      })
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.search-label {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// src/pages/common/InstanceSearch.vue